
export default ((x) => x.default || x)(
  // TODO: should be analyzed if we can find a better way to do this
  // eslint-disable-next-line global-require -- old style
  require('../components-implementation/street-view-panorama')
);
